import { render, staticRenderFns } from "./LinkActivity.vue?vue&type=template&id=7c289094&"
import script from "./LinkActivity.vue?vue&type=script&lang=ts&"
export * from "./LinkActivity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QMarkupTable} from 'quasar'
component.options.components = Object.assign({QMarkupTable}, component.options.components || {})
